import React, { useState, useEffect } from "react";
import "./PartnersGrid.css";

const partners = [
  {
    id: 1,
    name: "Bankers Assurance",
    logo: "http://www.bankers-assurance.com/Content/images/facebookLogo.png",
  },
  {
    id: 2,
    name: "AXA Middle East",
    logo: "https://i.ibb.co/xJmDxQ8/AXA-MIDDLE-EAST-1.png",
  },
  {
    id: 3,
    name: "Fidelity",
    logo: "https://i.ibb.co/PmLgjgw/FIDELITY-1.png",
  },
  {
    id: 4,
    name: "MEDGULF",
    logo: "https://i.ibb.co/DDgTR1L/MEDGULF-1.png",
  },
  {
    id: 5,
    name: "ARABIA",
    logo: "https://i.ibb.co/rK9QcmF/ARABIA-1.png",
  },
  {
    id: 6,
    name: "Alig",
    logo: "https://i.ibb.co/TcF06C3/Alig-new.png",
  },
  {
    id: 7,
    name: "Mutuelle Olivier",
    logo: "https://www.mutuelleolivier.com/images/logo-green.png",
  },
  {
    id: 8,
    name: "Compass Trust",
    logo: "/company/trust.png",
  },
  {
    id: 9,
    name: "ATI",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQizeHASbvFpoKj-yl5nioLr1Z36dXaoNpi3w&s",
  },
  {
    id: 10,
    name: "La Phenicienne",
    logo: "https://i.ibb.co/DMSZk6T/la-phenicienne-1.jpg",
  },
];

const PartnersGrid = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Auto-rotate highlight every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % partners.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="partners-grid-container">
      <div className="partners-grid">
        {partners.map((partner, index) => {
          const isActive = activeIndex === index;
          const isHovered = hoveredIndex === index;
          const shouldHighlight = isActive || isHovered;

          return (
            <div
              key={partner.id}
              className="partner-card-wrapper"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Card Container */}
              <div
                className={`partner-card ${shouldHighlight ? "highlighted" : ""}`}
              >
                {/* Glowing border effect */}
                {shouldHighlight && (
                  <div className="glow-overlay" />
                )}

                {/* Logo Container */}
                <div className="partner-logo-container">
                  <div
                    className={`partner-logo-wrapper ${
                      shouldHighlight ? "highlighted" : ""
                    }`}
                  >
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className={`partner-logo ${
                        shouldHighlight ? "highlighted" : ""
                      }`}
                    />
                  </div>
                </div>

                {/* Shine effect on hover */}
                <div className="shine-effect" />
              </div>

              {/* Partner name - show on auto-highlight or hover */}
              <div
                className={`partner-name ${
                  shouldHighlight ? "visible" : ""
                }`}
              >
                {partner.name}
              </div>
            </div>
          );
        })}
      </div>

      {/* Animation indicators */}
      <div className="partners-indicators">
        {partners.map((partner, index) => (
          <div
            key={`indicator-${partner.id}`}
            className={`indicator ${activeIndex === index ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default PartnersGrid;

